
ADILF.define('adilf/apps/profile/views/content-view',['require','exports','module','streamhub-sdk/jquery','inherits','adilf/context','streamhub-sdk/content/types/livefyre-content','view','view/composite-view','adilf/apps/profile/views/content-summary-view','streamhub-sdk/content/views/tiled-attachment-list-view','streamhub-sdk/content/views/block-attachment-list-view'],function (require, exports, module) {'use strict';

var jquery = require('streamhub-sdk/jquery');
var inherits = require('inherits');
var Context = require('adilf/context');
var LivefyreContent = require('streamhub-sdk/content/types/livefyre-content');
var View = require('view');
var CompositeView = require('view/composite-view');
var ProfileSummaryView = require('adilf/apps/profile/views/content-summary-view');
var TiledAttachmentListView = require('streamhub-sdk/content/views/tiled-attachment-list-view');
var BlockAttachmentListView = require('streamhub-sdk/content/views/block-attachment-list-view');

var CLASS_PREFIX = 'adi-profile-content';

var ProfileContentView = function (opts) {
    opts = opts || {};
    this._prefix = opts.prefix;
    this.content = opts.content;
    this.createdAt = new Date(); // store construction time to use for ordering if this.content has no dates
    CompositeView.call(this, opts);
    this._addInitialChildViews(opts);

    if (this.content) {
        this.content.on("change:visibility", function(newVis, oldVis) {
            this._handleVisibilityChange(newVis, oldVis);
        }.bind(this));

        this.content.on("change:featured", function (newVal, oldVal) {
            this._handleFeaturedChange(newVal, oldVal);
        }.bind(this));

        this.content.on("change:body", function(newVal, oldVal){
            this._handleBodyChange();
        }.bind(this));
    }
};
inherits(ProfileContentView, CompositeView);

ProfileContentView.prototype.elTag = 'div';
ProfileContentView.prototype.elClass = 'content ' + CLASS_PREFIX;
ProfileContentView.prototype.contentWithImageClass = 'content-with-image';
ProfileContentView.prototype.imageLoadingClass = 'hub-content-image-loading';
ProfileContentView.prototype.invalidClass = 'content-invalid';
ProfileContentView.prototype.attachmentsElSelector = '.content-attachments';
ProfileContentView.prototype.attachmentFrameElSelector = '.content-attachment-frame';

ProfileContentView.prototype.events = CompositeView.prototype.events.extended({
    'imageLoaded.hub': function(e) {
        this.$el.addClass(this.contentWithImageClass);
        this.$el.removeClass(this.imageLoadingClass);

        e.stopPropagation();
        this.$el.parent().trigger('imageLoaded.hub', { contentView: this });
    },
    'imageError.hub': function(e, oembed) {

        this.content.removeAttachment(oembed);

        if (this._thumbnailAttachmentsView && !this._thumbnailAttachmentsView.tileableCount()) {
            this.$el.removeClass(this.contentWithImageClass);
            this.$el.removeClass(this.imageLoadingClass);
        }

        e.stopPropagation();
        this.$el.parent().trigger('imageError.hub', { oembed: oembed, contentView: this });
    }
});

ProfileContentView.prototype._addInitialChildViews = function (opts) {
    this._thumbnailAttachmentsView = new TiledAttachmentListView(opts);
    this._blockAttachmentsView = new BlockAttachmentListView(opts);
    this._attachmentsView = new CompositeView(this._thumbnailAttachmentsView, this._blockAttachmentsView);
    this.add(this._attachmentsView, { render: false });

    this._summaryView = new ProfileSummaryView(opts);
    this.add(this._summaryView, { render: false });

};

ProfileContentView.prototype.setElement = function (el) {
    CompositeView.prototype.setElement.apply(this, arguments);

    if (this._thumbnailAttachmentsView && this._thumbnailAttachmentsView.tileableCount()) {
        this.$el.addClass(this.imageLoadingClass);
    }

    if (this.content && this.content.id) {
        this.$el.attr('data-content-id', this.content.id);
    }

    return this;
};

ProfileContentView.prototype._handleVisibilityChange = function(newVis, oldVis) {
    if (newVis !== 'EVERYONE') {
        this.remove();
    }
};

ProfileContentView.prototype._handleFeaturedChange = function (newVal, oldVal) {
    this._summaryView.render();
};

ProfileContentView.prototype._handleBodyChange = function (newVal, oldVal) {
    this._summaryView.render();
};

module.exports = ProfileContentView;

});
